import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';

const ImportCreateSkeleton = (): React.JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="start"
      height="100%"
    >
      <Typography variant="h1">
        <Skeleton height={90} />
      </Typography>

      <Typography variant="h2" marginBottom={2}>
        <Skeleton />
      </Typography>

      <Skeleton variant="rectangular" height={400} />
    </Box>
  );
};

export default ImportCreateSkeleton;
